/***************/
/**  IMPORTS  **/
/***************/
import { useState } from 'react';
import Cookies from "universal-cookie";

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/
import { Amplify } from 'aws-amplify';
import amplifyconfig from '../amplifyconfiguration.json';
import { post } from 'aws-amplify/api';

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import { useAuth } from '../utils/AuthContext';
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import notification_icon from "../assets/notification_icon.svg";
import { PageContainer,
         Header,
         Body,
         Toggle,
         } from "../styles/NotificationsPageStyles";

export default function NotificationsPage(){

    const { userData, getUserDetails } = useAuth();

    var email_toggle;
    var text_toggle;

    if(userData.email_alerts){
        email_toggle = "ON";
    } else {
        email_toggle = "OFF";
    }
    if(userData.text_alerts){
        text_toggle = "ON";
    } else {
        text_toggle = "OFF";
    }
    const [emailToggle, setEmailToggle] = useState(email_toggle);
    const [textToggle, setTextToggle] = useState(text_toggle);

    const cookies = new Cookies();
    const token = cookies.get("TOKEN");

    Amplify.configure(amplifyconfig);

    /**  HANDLES TOGGLING THE EMAIL ALERTS ON/OFF  **/
    const handleEmailToggle = async (email_toggle) => {
        
        const email = localStorage.getItem("EMAIL");
        try {
            setEmailToggle(email_toggle);
            const tog = email_toggle === "ON" ? true : false;

            const toggle = post({
                apiName: 'UserAPI',
                path: '/user/toggle_email_alerts',
                options: {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    body: {
                        tog,
                        email,
                    },
                }
            });

            const { body } = await toggle.response;
            const res = await body.json();
            console.log(res);
            console.log('Toggling email alerts POST call succeeded');
            getUserDetails();

        } catch (e) {
            console.log('Toggling email alerts POST call failed: ', e);
        }


    };

    /**  HANDLES TOGGLING THE EMAIL ALERTS ON/OFF  **/
    const handleTextToggle = async (text_toggle) => {
        
        const email = localStorage.getItem("EMAIL");
        try {
            setTextToggle(text_toggle);
            const tog = text_toggle === "ON" ? true : false;
            const toggle = post({
                apiName: 'UserAPI',
                path: '/user/toggle_text_alerts',
                options: {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    body: {
                        tog,
                        email,
                    },
                }
            });

            const { body } = await toggle.response;
            const res = await body.json();
            console.log(res);
            console.log('Toggling text alerts POST call succeeded');

        } catch (e) {
            console.log('Toggling text alerts POST call failed: ', e);
        }


    };

    return (
        <>
            <Navbar />
            <div style={{display: "flex", justifyContent: "center", flexDirection: "row"}}>
                <PageContainer>
                    <div style={{display: "flex", flexDirection: "row"}}>
                        <Sidebar></Sidebar>
                        <img alt="notification_icon" src={notification_icon} style={{marginLeft: 30, paddingTop: "5px"}} />
                        <Header>Notification Settings</Header>
                    </div>
                    <div style={{display: "flex", flexDirection: "row"}}>
                        <Body>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginBottom: "20px"}}>
                                <div style={{display: "flex", flexDirection: "column", marginRight: "30px", width: "100px"}}>
                                    Email Alerts
                                </div>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <Toggle
                                        toggle={emailToggle === "ON"}
                                        onClick={() => {handleEmailToggle("ON")}}>
                                        ON
                                    </Toggle>
                                    
                                </div>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <Toggle
                                        toggle={emailToggle === "OFF"}
                                        onClick={() => {handleEmailToggle("OFF")}}>
                                        OFF
                                    </Toggle>
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"}}>
                                <div style={{display: "flex", flexDirection: "column", marginRight: "30px", width: "100px"}}>
                                    Text Alerts
                                </div>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <Toggle
                                        toggle={textToggle === "ON"}
                                        onClick={() => handleTextToggle("ON")}>
                                        ON
                                    </Toggle>
                                    
                                </div>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                <Toggle
                                        toggle={textToggle === "OFF"}
                                        onClick={() => handleTextToggle("OFF")}>
                                        OFF
                                    </Toggle>
                                </div>
                            </div>
                        </Body>
                    </div>
                </PageContainer>
            </div>
        </>
    )
}